import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwayPrincipal() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Principal",
        level: 6,
        emoji: "\ud83e\udd89",
        color: "indigo",
        comingSoon: true,
        description: "",
        sections: [],
        prev: { name: "Anterior: Staff", url: "/growth/career-pathway/staff" },
      }}
    />
  )
}

CareerPathwayPrincipal.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
